import React from "react";
import { Link, useLocation } from "react-router-dom";

import "./RenderDownloadUnavailable.css";

export default function RenderDownloadUnavailable() {
  const location = useLocation();
  const reason = new URLSearchParams(location.search).get("reason");
  const isInvalid = reason === "invalid";

  return (
    <main className="render-download-unavailable">
      <section className="render-download-unavailable__card">
        <Link
          className="render-download-unavailable__brand"
          to="/"
          aria-label="ScrollX home"
        >
          ScrollX
        </Link>
        <div
          className="render-download-unavailable__icon"
          aria-hidden="true"
        >
          <span>!</span>
        </div>
        <p className="render-download-unavailable__eyebrow">
          Render download
        </p>
        <h1>{isInvalid ? "Link unavailable" : "Download link expired"}</h1>
        <p className="render-download-unavailable__message">
          {isInvalid
            ? "This download link is invalid or no longer available."
            : "Render files are available for five days after completion. Your project is still saved, so you can open it and create a new render."}
        </p>
        <Link
          className="render-download-unavailable__button"
          to="/dashboard"
        >
          Return to ScrollX
        </Link>
        <p className="render-download-unavailable__help">
          Need help? <Link to="/contactus">Contact us</Link>
        </p>
      </section>
    </main>
  );
}
